/**
 * Unauthorized Page
 * Se muestra cuando el usuario no tiene permisos para acceder a una página.
 *
 * HIPAA Requirement: 45 CFR 164.308(a)(4) - Information Access Management
 */
import React, { useContext } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { usePermissions } from "../../context/PermissionsContext";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = usePermissions();
  const { user } = useContext(AuthContext);

  // Nombre real del rol que envía el backend; el `userRole` mapeado (tier) es
  // solo fallback — mostrarlo a secas decía "guest" para roles nuevos no mapeados.
  const roleLabel = user?.activeRole?.name || userRole || "Not defined";

  const from = location.state?.from?.pathname || "/Main";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 450,
          textAlign: "center",
        }}
      >
        <LockOutlinedIcon
          sx={{ fontSize: 80, color: "warning.main", mb: 2 }}
        />

        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You don't have permission to access this section.
          {from !== "/Main" && (
            <>
              <br />
              <strong>Requested route:</strong> {from}
            </>
          )}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Your current role: <strong>{roleLabel}</strong>
        </Typography>

        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 3 }}>
          If you believe you should have access, contact your system administrator.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => navigate("/Main")}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
